// Royal Phuket Marina Campaign Performance Data
export const initialChannels = [
  {
    id: "fb_aus",
    name: "Facebook Ads — Leads AUS (Waterfront Villa)",
    channelGroup: "Facebook Ads",
    project: "Royal Phuket Marina",
    color: "#1877F2",
    leads: 55,
    qualified: 38,
    reach: "8,601",
    impressions: "25,788",
    cpc: "฿40.11",
    conversionRate: "12.8%",
    costPerLead: "฿423.74",
    amountSpent: "฿23,305.78",
    qualityScore: 92,
    trend: "+18.4%"
  },
  {
    id: "fb_hk_lookalike",
    name: "Facebook Ads — Leads HK (Office Leasing)",
    channelGroup: "Facebook Ads",
    project: "Royal Phuket Marina",
    color: "#1877F2",
    leads: 20,
    qualified: 14,
    reach: "5,257",
    impressions: "14,316",
    cpc: "฿50.51",
    conversionRate: "10.5%",
    costPerLead: "฿659.59",
    amountSpent: "฿13,191.79",
    qualityScore: 88,
    trend: "+12.1%"
  },
  {
    id: "fb_phuket_lookalike",
    name: "Facebook Ads — Leads Phuket (Marina Berth)",
    channelGroup: "Facebook Ads",
    project: "Royal Phuket Marina",
    color: "#1877F2",
    leads: 19,
    qualified: 12,
    reach: "13,329",
    impressions: "71,070",
    cpc: "฿14.91",
    conversionRate: "8.4%",
    costPerLead: "฿605.14",
    amountSpent: "฿11,497.66",
    qualityScore: 85,
    trend: "+15.0%"
  },
  {
    id: "fb_sg",
    name: "Facebook Ads — Leads SG (Commercial & Retail)",
    channelGroup: "Facebook Ads",
    project: "Royal Phuket Marina",
    color: "#1877F2",
    leads: 19,
    qualified: 11,
    reach: "6,986",
    impressions: "22,987",
    cpc: "฿27.47",
    conversionRate: "9.2%",
    costPerLead: "฿889.15",
    amountSpent: "฿16,893.82",
    qualityScore: 84,
    trend: "+9.2%"
  },
  {
    id: "fb_uk",
    name: "Facebook Ads — Leads UK (Luxury Residence)",
    channelGroup: "Facebook Ads",
    project: "Royal Phuket Marina",
    color: "#1877F2",
    leads: 12,
    qualified: 8,
    reach: "6,448",
    impressions: "16,332",
    cpc: "฿46.14",
    conversionRate: "7.8%",
    costPerLead: "฿1,245.66",
    amountSpent: "฿14,947.95",
    qualityScore: 80,
    trend: "+5.4%"
  },
  {
    id: "google_office",
    name: "Google Search — Commercial Office",
    channelGroup: "Google Ads",
    project: "Royal Phuket Marina",
    color: "#0F766E",
    leads: 46,
    qualified: 32,
    reach: "691 clicks",
    impressions: "9,400",
    cpc: "฿17.57",
    conversionRate: "6.64%",
    costPerLead: "฿346.61",
    amountSpent: "฿15,905.65",
    qualityScore: 94,
    trend: "+22.5%"
  },
  {
    id: "google_berth",
    name: "Google Search — Marina Berth & Villa",
    channelGroup: "Google Ads",
    project: "Royal Phuket Marina",
    color: "#0F766E",
    leads: 27,
    qualified: 18,
    reach: "514 clicks",
    impressions: "9,010",
    cpc: "฿17.57",
    conversionRate: "5.25%",
    costPerLead: "฿200.56",
    amountSpent: "฿5,415.22",
    qualityScore: 91,
    trend: "+14.0%"
  }
];
